import React from 'react';
import { useAuthService } from '@/contexts/authService';

const WithAuthService = (ChildComponent) => {
  return (props) => {
    const authService = useAuthService();
    return <ChildComponent authService={authService} {...props} />;
  };
};
export default WithAuthService;
